import { useEffect, useState } from "react";
import {
  AddTaskModelContainer,
  // ButtonDeletedSelectedTime,
  ButtonSave,
  CloseButtonAddModel,
  ContainerButtonSave,
  ContainerDataTask,
  ContainerRemiderTask,
  DataAndTimeContainer,
  HeaderModel,
  // SelectTime,
  TextCount,
  TextDescriptionInput,
  TextInput,
  TitleAddModel,
  TitleTask,
  TitleText,
} from "./AddTaskModel.styled";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import "./stylesCalenders.css";
import { useLanguageContext } from "../../../../../../Components/Languages/Langs/LanguageContext";
import { useAppDispatch } from "../../../../../../Redux/store";
import {
  addNewTask,
  getAllTasks,
} from "../../../../../../Redux/tasks/operators";
import { CloseButtonIcon } from "../../Icons/icons";
import { CalendarComponent } from "./Calendar/CalendarComponent";
import { TimePickerComponent } from "./Time/TimeComponent";
// import { sendPushNotification, subscribeToPush } from "./RequestsAPI";

interface AddTaskModelProps {
  onClose: () => void;
}

export const AddTaskModel: React.FC<AddTaskModelProps> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const { t } = useLanguageContext();

  // Ліміт символів
  const NAME_MAX: number = 30;
  const DESCRIPTION_MAX: number = 200;

  interface ErrorFormTask {
    name?: string;
    description?: string;
    date?: string;
    time?: string;
  }

  const [nameTask, setNameTask] = useState<string | null>(null);
  const [nameCount, setNameCount] = useState<number>(0);
  const [description, setDescription] = useState<string>("");
  const [dateTask, setDateTask] = useState<string>("");
  const [selectedTime, setSelectedTime] = useState<string>("");
  const [formErrors, setFormErrors] = useState<ErrorFormTask>({});
  const [descriptionCount, setDescriptionCount] = useState<number>(0);

  const KEY_COUNT_NAME: string = "count-sybmol-name";
  const ENTERED_NAME_TASK: string = "name-entered";
  const ENTERED_TEXT_TASK: string = "text-entered";
  const KEY_COUNT_DESCRIPTION: string = "count-sybmol-desctiption";

  const handleNameChange = (value: string) => {
    setNameCount(value.length);
    setNameTask(value);

    if (value.length > NAME_MAX) {
      setFormErrors((prev) => ({
        ...prev,
        name: `Name must not exceed ${NAME_MAX} characters`,
      }));
    } else {
      setFormErrors((prev) => ({ ...prev, name: undefined }));
    }

    localStorage.setItem(ENTERED_NAME_TASK, value.toString());
    localStorage.setItem(KEY_COUNT_NAME, value.length.toString());
  };

  const handleDescriptionChange = (value: string) => {
    setDescriptionCount(value.length);
    setDescription(value);

    if (value.length > DESCRIPTION_MAX) {
      setFormErrors((prev) => ({
        ...prev,
        description: `Description must not exceed ${DESCRIPTION_MAX} characters`,
      }));
    } else {
      setFormErrors((prev) => ({ ...prev, description: undefined }));
    }

    localStorage.setItem(ENTERED_TEXT_TASK, value.toString());
    localStorage.setItem(KEY_COUNT_DESCRIPTION, value.length.toString());
  };

  const formAddNewTask = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();

    // Локальна перевірка maxlength перед відправкою
    if (nameCount > NAME_MAX || descriptionCount > DESCRIPTION_MAX) {
      return;
    }

    try {
      const res = await dispatch(
        addNewTask({
          name: nameTask?.trim() || "",
          description: description.trim(),
          date: dateTask,
          time: selectedTime,
        }),
      ).unwrap();

      await dispatch(getAllTasks());

      setFormErrors({ name: undefined, description: undefined });
      toast.success(res.name ? res.name : "Task added successfully!");
      clearStorage("count-sybmol-name");
      clearStorage("name-entered");
      clearStorage("text-entered");
      clearStorage("count-sybmol-desctiption");

      onClose();
    } catch (error) {
      console.log("Unwrapped error:", error);

      if (typeof error === "object" && error !== null) {
        const typedError = error as ErrorFormTask;
        setFormErrors(typedError);
      } else {
        toast.error(t("privateTraslate.updateDataUserPageNameErrorServer"));
      }
    }
  };

  const clearStorage = (key: string) => {
    localStorage.removeItem(key);
  };

  const [startDate, setStartDate] = useState<Date | null>(new Date());

  useEffect(() => {
    const now = new Date();
    const formattedDate = moment(now).format("MM.DD.YY"); // крапки
    setDateTask(formattedDate);
  }, []);

  // fix bag Date must be in the format 'MM.DD.YY

  // time picker

  useEffect(() => {
    const now = new Date();
    const h = String(now.getHours()).padStart(2, "0");
    const m = String(now.getMinutes()).padStart(2, "0");
    setSelectedTime(`${h}:${m}`);
  }, []);

  useEffect(() => {
    const dataCountName = localStorage.getItem(KEY_COUNT_NAME);
    if (dataCountName) {
      setNameCount(Number(dataCountName));
    }

    const enteredNameNewTask = localStorage.getItem(ENTERED_NAME_TASK);
    if (enteredNameNewTask) {
      setNameTask(enteredNameNewTask);
    }

    const dataCountDescription = localStorage.getItem(KEY_COUNT_DESCRIPTION);
    if (dataCountDescription) {
      setDescriptionCount(Number(dataCountDescription));
    }

    const enteredTextNewTask = localStorage.getItem(ENTERED_TEXT_TASK);
    if (enteredTextNewTask) {
      setDescription(enteredTextNewTask);
    }
  }, []);

  const initialTimes = () => [
    {
      label: `5 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 5 * 60000,
    },
    {
      label: `10 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 10 * 60000,
    },
    {
      label: `15 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 15 * 60000,
    },
    {
      label: `20 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 20 * 60000,
    },
    {
      label: `25 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 25 * 60000,
    },
    {
      label: `30 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 30 * 60000,
    },
    {
      label: `35 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 35 * 60000,
    },
    {
      label: `40 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 40 * 60000,
    },
    {
      label: `45 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 45 * 60000,
    },
    {
      label: `50 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 50 * 60000,
    },
    {
      label: `55 ${t("privateTraslate.model-window-add-task-minutes")}`,
      valueInMs: 55 * 60000,
    },
    {
      label: `1 ${t("privateTraslate.model-window-add-task-hour")}`,
      valueInMs: 1 * 3600000,
    },
  ];

  const availableTimesValue = initialTimes();

  const [availableTimes, setAvailableTimes] = useState(availableTimesValue);
  localStorage.setItem("seleced-time", JSON.stringify(availableTimes));
  // const [selectTimeNotification, setSelectTimeNotification] =
  //   useState<string>("");
  // const [disableButtonDelete, setDisableButtonDelete] =
  //   useState<boolean>(false);

  // useEffect(() => {
  //   localStorage.setItem("seleced-time", JSON.stringify(availableTimes));
  // }, [availableTimes]);

  // const pushNotification = (time: number) => {
  //   if (!("Notification" in window)) {
  //     alert("Notifications are not supported in your browser.");
  //     return;
  //   }

  //   if (Notification.permission === "granted") {
  //     new Notification("SafeTasker Notification", {
  //       body: `You have ${time} left. Before your task ${nameTask}`,
  //       // icon: "../../../img/Logo-notification.jpg",
  //     });
  //   } else {
  //     console.log("Notification permission is not granted.");
  //   }
  // };

  // const deleteButtons = () => {
  //   const newDisableState = !disableButtonDelete;

  //   setDisableButtonDelete(true);
  //   localStorage.setItem("delete-buttons", JSON.stringify(newDisableState));
  // };

  // const resetSelectTime = () => {
  //   setSelectTimeNotification("");
  //   localStorage.removeItem("selected-time-notification-task");
  // };

  // const handleOptionClick = async (
  //   evt: React.ChangeEvent<HTMLSelectElement>,
  // ) => {
  //   const selectedLabel = evt.target.value;
  //   setSelectTimeNotification(selectedLabel);

  //   const timeObj = availableTimes.find((t) => t.label === selectedLabel);
  //   if (!timeObj) return;

  //   const delay = timeObj.valueInMs;

  //   const subscription = await subscribeToPush();
  //   if (subscription) {
  //     await sendPushNotification({
  //       subscription,
  //       title: "SafeTasker Notification",
  //       body: `You have a task: ${nameTask} at ${dateTask} ${selectedTime}`,
  //       image: "/img/Logo-notification.jpg",
  //       timeDelay: delay,
  //     });
  //   }

  //   setTimeout(() => {
  //     pushNotification(delay / 60000);
  //   }, delay);

  //   localStorage.setItem("selected-time-notification-task", selectedLabel);
  //   deleteButtons();
  // };

  useEffect(() => {
    // Завантажуємо збережений вибір часу
    // const savedNotificationTime = localStorage.getItem(
    //   "selected-time-notification-task",
    // );
    // if (savedNotificationTime) {
    //   setSelectTimeNotification(savedNotificationTime);
    // }

    // Завантажуємо доступні часи
    const savedAvailableTimes = localStorage.getItem("seleced-time");
    if (savedAvailableTimes) {
      setAvailableTimes(JSON.parse(savedAvailableTimes));
    }
  }, []);

  return (
    <>
      <AddTaskModelContainer>
        <HeaderModel>
          <TitleAddModel>
            {t("privateTraslate.Models.AddModelTitle")}
          </TitleAddModel>
          <CloseButtonAddModel type="button" onClick={onClose}>
            <CloseButtonIcon />
          </CloseButtonAddModel>
        </HeaderModel>
        <form onSubmit={formAddNewTask}>
          <ContainerDataTask>
            <TitleTask>
              {t("privateTraslate.Models.AddModelTextNameTask")}
            </TitleTask>
            <TextCount>
              {nameCount}/{NAME_MAX}
            </TextCount>
          </ContainerDataTask>
          <TextInput
            type="text"
            placeholder={t("privateTraslate.Models.AddModelTextNameTaskInput")}
            value={nameTask || ""}
            onChange={(e) => handleNameChange(e.target.value)}
          />
          {formErrors.name && (
            <span style={{ color: "red" }}>{formErrors.name}</span>
          )}

          <ContainerDataTask>
            <TitleTask>
              {t("privateTraslate.Models.AddModelTextDescriptionTask")}
            </TitleTask>
            <TextCount>
              {descriptionCount}/{DESCRIPTION_MAX}
            </TextCount>
          </ContainerDataTask>
          <TextDescriptionInput
            type="text"
            placeholder={t("privateTraslate.Models.AddModelTextUser")}
            value={description || ""}
            onChange={(e) => handleDescriptionChange(e.target.value)}
          />
          {formErrors.description && (
            <p style={{ color: "red" }}>{formErrors.description}</p>
          )}
          <DataAndTimeContainer>
            <div>
              <TitleText>
                {t("privateTraslate.Models.AddModelDataTask")}
              </TitleText>
              <CalendarComponent
                value={startDate || new Date()}
                onChange={(newDate) => {
                  setStartDate(newDate);
                  const formattedDate = moment(newDate).format("MM.DD.YY");
                  setDateTask(formattedDate);
                }}
              />

              {formErrors.date && (
                <p style={{ color: "red" }}>{formErrors.date}</p>
              )}
            </div>
            <div>
              <TitleText>
                {t("privateTraslate.Models.AddModelTimeTask")}
              </TitleText>
              <TimePickerComponent
                value={selectedTime}
                onChange={(val) => setSelectedTime(val)}
              />
              {formErrors.time && (
                <p style={{ color: "red" }}>{formErrors.time}</p>
              )}
            </div>
          </DataAndTimeContainer>

          <ContainerRemiderTask>
            {/* <SelectTime
              name="select-time"
              value={selectTimeNotification}
              onChange={handleOptionClick}
            >
              {availableTimes.map((time, index) => (
                <option
                  key={index}
                  value={time.label}
                >
                  {time.label}
                </option>
              ))}
            </SelectTime>
            <ButtonDeletedSelectedTime type="button" onClick={resetSelectTime}>
              {t("privateTraslate.Models.AddModelDeleteTimeTask")}
            </ButtonDeletedSelectedTime> */}
          </ContainerRemiderTask>
          <ContainerButtonSave>
            <ButtonSave type="submit">
              {t("privateTraslate.Models.AddModelButtonSave")}
            </ButtonSave>
          </ContainerButtonSave>
        </form>
      </AddTaskModelContainer>
      <ToastContainer />
    </>
  );
};
